import { ClientState } from '../types';

export const isSaveDisabled = ({
  clientName,
  unitId,
  locationDtoSet,
}: ClientState): boolean => !(clientName && unitId && locationDtoSet[0]?.name);
